// @ts-expect-error untyped dep
import { handleActions, combineActions } from 'flux-actions';
import SecurityPhoneNumber from '../../records/security/SecurityPhoneNumber';
import { SecurityPhoneNumberActionTypes } from '../../actions/security/SecurityPhoneNumberActions';
const initialState = new SecurityPhoneNumber();
export default handleActions({
  [SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION](state) {
    return state.merge(initialState);
  },
  [combineActions(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_SUCCESSFUL, SecurityPhoneNumberActionTypes.CONFIGURE_SMS_SUCCESS, SecurityPhoneNumberActionTypes.CODE_ATTEMPT_SUCCESS)](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge(action.payload.securityPhoneNumber);
  },
  [SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_FAILED](state) {
    return state.merge(initialState);
  },
  [SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_SUCCESS](state) {
    return state.merge(initialState);
  }
}, initialState);